'use strict';

var _ = require('lodash');
var GridToolbarRefreshButtonController = function GridToolbarRefreshButtonController($scope, $filter) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function isNotificationAvailable() {
    return !_.isUndefined($scope.liveDataNotification) && $scope.liveDataNotification.total !== 0;
  }
  function isNoTooltipState() {
    return $scope.liveDataNotification === undefined || $scope.isDisabled();
  }
  $scope.isNotificationShown = function () {
    return $scope.isLiveData && isNotificationAvailable();
  };
  $scope.isDisabled = function () {
    return $scope.isLiveData && !isNotificationAvailable();
  };
  $scope.getLastRefreshedNotification = function () {
    return 'Last Refreshed - ' + rmMomentFormat($scope.lastRefreshed, 'DATE_TIME_USER_SETTINGS');
  };
  $scope.getNotificationContent = function () {
    if (isNoTooltipState()) {
      return;
    }
    return $scope.liveDataNotification.total + ' new Flight Dptr Date events:<br/>' + '- ' + $scope.liveDataNotification.l2Count + ' Booking Events<br/>' + '- ' + $scope.liveDataNotification.l3Count + ' Optimizations<br/><br/>' + $scope.getLastRefreshedNotification();
  };
};
GridToolbarRefreshButtonController.$inject = ['$scope', '$filter'];
module.exports = GridToolbarRefreshButtonController;